import { Reveal, SectionTag } from "./Reveal";
import { IndianRupee, Megaphone, ShieldCheck } from "lucide-react";

const BLOCKS = [
  {
    icon: IndianRupee,
    title: "What your monthly fee covers",
    text: "Monthly fees cover Nexus Catalyst services and deliverables: social media content, advertising campaign management, strategy calls, optimization and reporting, according to the package you choose.",
    testid: "transparency-fee",
  },
  {
    icon: Megaphone,
    title: "What advertising budget covers",
    text: "Advertising spend is paid toward the advertising platforms, such as Meta and Google, and is separate from agency fees. For Foundation we recommend a starting Meta budget of ₹10,000 per month. Growth and Scale budgets are determined according to your goals, market, package economics, campaign requirements and desired scale.",
    testid: "transparency-budget",
  },
  {
    icon: ShieldCheck,
    title: "What we never promise",
    text: "We do not guarantee leads, bookings, revenue, ROAS or ROI. Marketing performance depends on your market, offer, season, budget and your own team's follow-up. We commit to professional work and honest reporting, not invented outcomes.",
    testid: "transparency-honesty",
  },
];

export const FeeTransparency = () => (
  <section className="bg-white py-24 md:py-32 border-t border-charcoal/10" data-testid="fee-transparency">
    <div className="max-w-7xl mx-auto px-6">
      <Reveal className="mb-14 max-w-3xl">
        <SectionTag className="mb-6">Pricing Transparency</SectionTag>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-charcoal leading-[1.05]">
          Agency Fees and Advertising Budget Are Separate.
        </h2>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-6">
        {BLOCKS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.08} className="h-full">
            <div
              className="h-full bg-cream border border-charcoal/10 p-8"
              data-testid={b.testid}
            >
              <b.icon size={20} strokeWidth={1.5} className="text-gold" />
              <h3 className="mt-5 text-lg font-semibold tracking-tight text-charcoal">
                {b.title}
              </h3>
              <p className="mt-3 text-sm text-charcoal/60 leading-relaxed">
                {b.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
